<ng-container *ngIf="ctx" [ngSwitch]="mainService.getShopPortalLayoutKind(shopSoort.Banden)">
  <app-tyres-boxed-layout *ngSwitchDefault [ctx]="ctx" [tyreResult]="tyreResult" [tyres]="tyres" [set]="set"></app-tyres-boxed-layout>
  <app-tyres-scroll-layout *ngSwitchCase="1" [ctx]="ctx"  [tyreResult]="tyreResult" [tyres]="tyres" [set]="set"></app-tyres-scroll-layout>
</ng-container>
